import { StaticQuery, graphql } from 'gatsby';
import React from 'react';

import Link from '../components/Link';
import styles from './Header.module.scss';

const HeaderTemplate = ({ headerLinks, absolute }) => {
  const [isToggled, setToggle] = React.useState(false);

  return (
    <>
      <nav className={`${styles.header} ${absolute ? styles.absolute : ''}`}>
        <ul className={styles.menu}>
          <li>
            <div
              className={`${styles.navIcon} ${isToggled ? styles.toggled : ''}`}
              onClick={() => {
                setToggle(!isToggled);
              }}
            >
              <div></div>
            </div>
          </li>
          <Link to="/">
            <li className={styles.menuLogo}>LABELLE</li>
          </Link>
          {headerLinks &&
            headerLinks.map(({ url, title }) => (
              <Link to={url} key={title}>
                <li className={styles.menuItem}>{title}</li>
              </Link>
            ))}
        </ul>
      </nav>
      <div
        className={`${styles.hiddenMenu} ${isToggled ? styles.toggled : ''}`}
      >
        <ul className={styles.menu}>
          {headerLinks &&
            headerLinks.map(({ url, title }) => (
              <Link to={url} key={title}>
                <li className={styles.menuItem}>{title}</li>
              </Link>
            ))}
        </ul>
      </div>
    </>
  );
};

const Header = ({ absolute }) => {
  return (
    <StaticQuery
      query={graphql`
        query HeaderQuery {
          items: markdownRemark(frontmatter: { type: { eq: "layout-vars" } }) {
            frontmatter {
              headerLinks {
                title
                url
              }
            }
          }
        }
      `}
      render={({ items }) => (
        <HeaderTemplate
          absolute={absolute}
          headerLinks={items.frontmatter.headerLinks}
        />
      )}
    />
  );
};

export { HeaderTemplate, Header as default };
